export default {"src":"/_next/static/media/contact.5791755c.svg","height":800,"width":800,"blurWidth":0,"blurHeight":0};